module.exports = __webpack_public_path__ + "img/off-white.fd914a34.svg";